export default {
    "de": {
        "app": {
            "home": {
                "title": "Freie Arbeitsplätze",
                "text_1": "Hier sehen Sie, wie viele freie Plätze es aktuell in den Universitätsbibliotheken von TU Berlin und UdK Berlin gibt.",
                "text_2": "Die genaue Anzahl kann aufgrund von Verzögerungen bei der Immatrikulation von TU-Studierenden ggf. abweichen, da der Check-In für diese Personen nicht möglich ist.",
                "text_refresh_websockets": "Die Daten werden live aktualisiert.",
                "text_refresh_polling": "Die Daten werden alle {refreshRateInSeconds} Sekunden aktualisiert.",
                "info_link_url": "https://www.tu.berlin/ub/nachrichtendetails/keine-platzbuchung-mehr-notwendig-ab-23-august-2021/",
                "info_link_text": "Weitere Informationen"
            },
            "overview": {
                "status_closed": "Geschlossen",
                "free_spaces": "{free_spaces} frei",
                "available_spaces": "{available_spaces} Plätze gesamt"
            },
            "check_in": {
                "title": "Check-In",
                "text_1": "Bitte scannen Sie Ihren Bibliotheksausweis ein.",
                "text_2": "Mit dem Einscannen des Bibliotheksausweises bestätigen Sie, dass Sie sich gesund fühlen. Wenn Sie Erkältungssymptome haben (z.B. Fieber oder Husten), dürfen Sie die Universitätsbibliothek nicht betreten.",
                "form": {
                    "barcode": {
                        "placeholder": "Ihr Barcode"
                    }
                },
                "status": {
                    "title_success": "Check-In erfolgreich",
                    "title_failure": "Check-In nicht erfolgreich",
                    "text": {
                        "no_connection": "Keine Verbindung zum Webservice möglich.",
                        "processed": "Bitte nehmen Sie einen farbigen Korb.",
                        "invalid": "Der Barcode <strong>{barcode}</strong> hat ein falsches Format.",
                        "closed": "Dieser Standort ist geschlossen.",
                        "no_spaces_left": "Momentan sind alle Arbeitsplätze besetzt.",
                        "existing_check_in": "Der Barcode <strong>{barcode}</strong> ist bereits eingecheckt. Haben Sie vergessen, sich auszuchecken?",
                        "not_found": "Der Barcode <strong>{barcode}</strong> ist unbekannt.",
                        "expired": "Das Konto mit dem Barcode <strong>{barcode}</strong> ist abgelaufen.",
                        "block": "Das Konto mit dem Barcode <strong>{barcode}</strong> ist gesperrt.",
                        "user_group_deny": "Die Benutzergruppe des Kontos mit dem Barcode <strong>{barcode}</strong> ist nicht erlaubt.",
                        "tech_err": "Technisches Problem. Bitte versuchen Sie es später noch einmal.",
                        "text_other_failure": "Anderer Fehler"
                    }
                }
            },
            "check_out": {
                "title": "Check-Out",
                "text_1": "Bitte scannen Sie Ihren Bibliotheksausweis ein.",
                "form": {
                    "barcode": {
                        "placeholder": "Ihr Barcode"
                    }
                },
                "status": {
                    "title_success": "Auf Wiedersehen",
                    "title_failure": "Check-Out nicht erfolgreich",
                    "text": {
                        "processed": "Bitte stellen Sie Ihren Korb zurück.",
                        "invalid": "Der Barcode <strong>{barcode}</strong> hat ein falsches Format.",
                        "no_existing_check_in": "Wir können keinen Check-In mit dem Barcode <strong>{barcode}</strong> finden. Haben Sie vergessen, sich einzuchecken?"
                    }
                }
            },
            "visit": {
                "title": "Besucherzähler",
                "form": {
                    "visitor_in": {
                        "value": "Rein"
                    },
                    "visitor_out": {
                        "value": "Raus"
                    }
                },
                "status": {
                    "title_success": "Auf Wiedersehen",
                    "title_failure": "Check-Out nicht erfolgreich",
                    "text": {
                        "ok": "Bitte stellen Sie Ihren Korb zurück."
                    }
                }
            }
        }
    },
    "en": {
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
